import Image from "./Image";
import Link from "./Link/Link";

export default function CustomElement({ attributes, children, element }) {
  const style = { textAlign: element.align };
  switch (element.type) {
    case "block-quote":
      return (
        <blockquote style={style} {...attributes}>
          {children}
        </blockquote>
      );
    case "bulleted-list":
      return (
        <ul style={style} {...attributes}>
          {children}
        </ul>
      );
    case "heading-one":
      return (
        <h3 style={style} {...attributes}>
          {children}
        </h3>
      );
    case "heading-two":
      return (
        <h4 style={style} {...attributes}>
          {children}
        </h4>
      );
    case "list-item":
      return (
        <li style={style} {...attributes}>
          {children}
        </li>
      );
    case "numbered-list":
      return (
        <ol style={style} {...attributes}>
          {children}
        </ol>
      );
    case "image":
      return (
        <Image
          style={style}
          attributes={attributes}
          children={children}
          element={element}
        />
      );

    case "link":
      return (
        <Link attributes={attributes} children={children} element={element} />
      );

    default:
      return (
        <p style={style} {...attributes}>
          {children}
        </p>
      );
  }
}
